import { Button } from 'component/Button'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

type Props = {
  type: 'main' | 'combo'
}

const ProductActions = ({ type }: Props) => {
  const { identity_id, saving } = store.profile
  const good = !!identity_id || !!saving
  const no_limit = !!identity_id && !store.available
  const main = type === 'main'
  const item = main ? store.item : store.comboItem
  const combine = !!opt.options.combine && !!item?.combine && !store.comboItemId

  const onCreate = useLatestCallback(async () => {
    controller.onClickTry()
    if (good) await controller.generateSingleItem(item)
    else controller.editProfile('generate')
  })

  const onCombine = useLatestCallback(() => {
    if (good) controller.openCombineForItem(item)
    else controller.editProfile('combine')
  })

  return (
    <Vertical wide gap={8}>
      <Button
        wide
        large
        primary
        action={onCreate}
        disabled={no_limit}
      >
        {i18n('TryItOnForYourself')}
      </Button>

      {combine && (
        <Button wide large action={onCombine} disabled={no_limit}>
          {i18n('CombineLook')}
        </Button>
      )}
    </Vertical>
  )
}

export default ProductActions
